// Utility to get authorization headers for API calls
// The ADMIN_API_SECRET is set as REACT_APP_ADMIN_API_SECRET in the frontend env
export function getAuthHeaders() {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${process.env.REACT_APP_ADMIN_API_SECRET || ''}`,
  };
}
